function getDateDayOfYear(value) {
  if (value == null) return '';
  const date = isDate(value) ? value : new Date(value);

  const year  = date.getFullYear().toString();
  const month = (date.getMonth() + 1).toString();
  const day   = date.getDate().toString();

  const monthPrefix = month.length === 1 ? '0' : '';
  const dayPrefix   = day.length === 1 ? '0' : '';

  return dayPrefix + day + '.' + monthPrefix + month + '.' + year;
}
function getDateTime(value) {
  if (value == null) return '';

  const date = new Date(value);

  const hour = date.getHours().toString();
  const minutes = date.getMinutes().toString();

  const hourPrefix    = hour.length === 1 ? '0' : '';
  const minutesPrefix = minutes.length === 1 ? '0' : '';

  return hourPrefix + hour + ':' + minutesPrefix + minutes;
}

function getDateString(value) {
  const date  = getDateDayOfYear(value);
  const hours = getDateTime(value);
  return `${date} ${hours}`;
}

function isDate(value) {
    return Object.prototype.toString.call(value) === '[object Date]';
}

export default {
  getDateDayOfYear,
  getDateTime,
  getDateString,
  isDate
};
